import { customPalette } from "../../../../theme/theme";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@mui/material";
import Box from "@mui/material/Box";

export function FooterTextLabel(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        ml: 4,
        whiteSpace: "nowrap",
      }}
    >
      <Typography color={customPalette.primary.contrastText}>
        {t("WEG:footerCopyright", { year: new Date().getFullYear() })}
      </Typography>
    </Box>
  );
}
